import { categories } from "@/mocks/comics";

const quickLinks = [
  { label: "热门推荐", href: "#featured" },
  { label: "分类浏览", href: "#categories" },
  { label: "每日更新", href: "#updates" },
  { label: "人气榜单", href: "#ranking" },
  { label: "阅读指南", href: "#features" },
  { label: "常见问题", href: "#faq" },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-800/60">
      <div className="mx-auto px-4 md:px-8 py-12 md:py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* 品牌 */}
        <div className="lg:col-span-1">
          <a href="#top" className="flex items-center gap-2 cursor-pointer">
            <span className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-600 text-background-950">
              <i className="ri-book-open-fill text-2xl" />
            </span>
            <span className="font-heading text-2xl font-bold text-foreground-50">
              韩漫<span className="text-primary-400">馆</span>
            </span>
          </a>
          <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
            韩漫馆专注提供韩漫免费无删减下拉式阅读体验，热门韩漫免费看全集，章节完整、每日更新，随时随地畅享高清韩漫免费阅读。
          </p>
        </div>

        {/* 快速导航 */}
        <nav aria-label="快速导航">
          <h4 className="text-sm font-semibold text-foreground-100 mb-4">快速导航</h4>
          <ul className="space-y-2.5">
            {quickLinks.map((l) => (
              <li key={l.label}>
                <a
                  href={l.href}
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* 分类 */}
        <nav aria-label="漫画分类">
          <h4 className="text-sm font-semibold text-foreground-100 mb-4">热门分类</h4>
          <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
            {categories.slice(0, 8).map((c) => (
              <li key={c.name}>
                <a
                  href="#categories"
                  className="text-sm text-foreground-400 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {c.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* 联系 */}
        <div>
          <h4 className="text-sm font-semibold text-foreground-100 mb-4">联系我们</h4>
          <ul className="space-y-3 text-sm text-foreground-400">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-primary-400" />
              support@hanmanguan.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-primary-400" />
              每日 09:00 - 23:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-message-3-line text-primary-400" />
              意见反馈与内容合作
            </li>
          </ul>
          <div className="mt-4 flex items-center gap-2">
            {["ri-wechat-line", "ri-qq-line", "ri-weibo-line"].map((ic) => (
              <a
                key={ic}
                href="#top"
                aria-label="社交媒体"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 hover:bg-primary-600 text-foreground-300 hover:text-background-950 transition-colors cursor-pointer"
              >
                <i className={`${ic} text-lg`} />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-background-800/60">
        <div className="mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
          <p>© {new Date().getFullYear()} 韩漫馆 · 韩漫免费无删减下拉阅读平台</p>
          <p className="flex items-center gap-1">
            <i className="ri-heart-3-fill text-accent-500" />
            畅享高清韩漫免费阅读体验
          </p>
        </div>
      </div>
    </footer>
  );
}